var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"digPop"},[_c('div',{staticClass:"digPopInner"},[_c('div',{staticClass:"digPopCont"},[_vm._t("default")],2),_c('a',{staticClass:"btnclose",attrs:{"href":"javascript:;"},on:{"click":_vm.fnEventBus}},[_vm._v("팝업닫기")])])])}
var staticRenderFns = []

export { render, staticRenderFns }